import { readAllData, STORES } from "utility"
import { mergeUpsertOffline } from "utils/offline/crud"

export async function getProfileOffline() {
  const profiles = await readAllData(STORES.PROFILE)
  return profiles?.[0] || null
}

function formDataToProfileFields(formData) {
  const updates = {}
  for (const [key, value] of formData.entries()) {
    // Un fichier ne peut pas être rejoué depuis la file d'attente offline
    // (JSON uniquement) ni utilement mis en cache pour une lecture hors ligne.
    if (value instanceof File || value instanceof Blob) continue
    updates[key] = value
  }
  return updates
}

// EditDoctor.jsx soumet un FormData (upload de logo). On l'ignore ici et on
// ne persiste que les champs texte du profil.
export async function editMyProfilOffline(formData) {
  const existing = await getProfileOffline()
  return mergeUpsertOffline(
    STORES.PROFILE,
    { ...formDataToProfileFields(formData), id: existing?.id ?? "me" },
    { markOffline: true },
  )
}

// Appelé juste après une sauvegarde réussie en ligne : sans ça, le cache
// IndexedDB reste figé sur le snapshot du dernier "Add to cache" et le mode
// hors ligne continue d'afficher l'ancien profil après une édition en ligne.
export async function cacheProfilAfterOnlineSave(formData) {
  const existing = await getProfileOffline()
  return mergeUpsertOffline(
    STORES.PROFILE,
    { ...formDataToProfileFields(formData), id: existing?.id ?? "me" },
    { markOffline: false },
  )
}
